package org.mkui.canvas

import org.mkui.font.CPFontMetrics
import web.canvas.CanvasRenderingContext2D
import web.canvas.TextMetrics

class ElementalFontMetrics(private val context: CanvasRenderingContext2D) : CPFontMetrics {
//    fun getStringBounds(text: String?): Rectangle2D {
//        val horizontalTextMetrics: TextMetrics = context.measureText(text)
//        val verticalTextMetrics: TextMetrics = context.measureText("M")
//        return Rectangle2D.Double(0.0, 0.0, horizontalTextMetrics.width, verticalTextMetrics.width)
//    }

    override fun getHeight(): Float {
        val verticalTextMetrics: TextMetrics = context.measureText("M")
        return verticalTextMetrics.width.toFloat()
    }

    override fun getAscent(): Int {
        val verticalTextMetrics: TextMetrics = context.measureText("M")
        return verticalTextMetrics.width.toInt()
    }
}
